import { useState, useCallback, useMemo } from "react";
import { debounce } from "../utils/common";

const useDebouncedSearch = (delay = 400) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const updateDebouncedSearch = useMemo(
    () => debounce((value) => setDebouncedSearch(value), delay),
    [delay]
  );

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearchQuery(value);
      updateDebouncedSearch(value);
    },
    [updateDebouncedSearch]
  );

  const resetSearch = useCallback(() => {
    setSearchQuery("");
    setDebouncedSearch("");
  }, []);

  return {
    searchQuery,
    debouncedSearch,
    handleSearchChange,
    resetSearch,
  };
};

export default useDebouncedSearch;
